import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { AccountDao } from '@app/dao/account/account.dao';
import { OptimizationDao } from '@app/dao/optimization/optimization.dao';
import { UserService } from '@app/providers/user/user.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { combineLatest, Subject } from 'rxjs';
import { EaOptimizationBuyOrRentFormBuilder } from './ea-optimization-buy-or-rent-form.builder';

@Component({
    selector: 'ea-optimization-buy-or-rent-form',
    templateUrl: './ea-optimization-buy-or-rent-form.component.html',
    styleUrls: ['./ea-optimization-buy-or-rent-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaOptimizationBuyOrRentFormComponent),
        },
    ],
    standalone: false
})
export class EaOptimizationBuyOrRentFormComponent
  extends EaOptimizationBuyOrRentFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();
  account: any;

  constructor(
    protected formConstructor: PrFormConstructor,
    private accountDao: AccountDao,
    private optimizationDao: OptimizationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.accountDao.getAccount().subscribe(account => {
      this.account = account;
    });
  }

  onSubmit() {
    this.prFormService.loading();
    this.optimizationDao
      .optimizeBuyOrRent(this.account.id, {
        ...this.extract(),
        type: 'BUY_OR_RENT',
      })
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (success) this.callback(success);
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }
}
